import { EventGroupPageDetails_EventsWithApprovalRequestsFragment } from 'sierra-client/api/graphql/gql/graphql'

export const getPendingApprovalRequests = (
  calenderEventRequests: Array<EventGroupPageDetails_EventsWithApprovalRequestsFragment>
): EventGroupPageDetails_EventsWithApprovalRequestsFragment['enrollmentRequestsToHandle'] => {
  return calenderEventRequests
    .filter(e => e.enrollmentRequestsToHandle.some(e => e.requestStatus === 'PENDING'))
    .flatMap(e => e.enrollmentRequestsToHandle)
}
